import { Avatar, Button, Divider, ListItem, ListItemText, Snackbar, Alert, Dialog, DialogTitle, DialogActions, Typography, DialogContent} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import * as S from '../../styles/common/UIComponents';
import { FlexContainer } from '../../styles/common/FlexBox';
import Gerais from '../Modal/Perfil/Gerais';
import useEditPbwUser from '../../hooks/useEditPbwUser';
import useDeleteUser from '../../hooks/useDeleteUser';
import { goToHome } from '../../routes/coordinator';
import { useNavigate } from 'react-router-dom';
import useEditUser from '../../hooks/useEditUser';
import { CircularProgress } from '@mui/material';
import { notifyAuthChanged } from '../../utils/dataLayer';

const PerfilContainer = ({user = {}}) => {

    const { editPbwUser, loading: loadingEditPbw } = useEditPbwUser();

    const { deleteUser, loading: loadingDelete } = useDeleteUser();

    const { editUser, loading: loadingEditUser } = useEditUser();
    const loading = loadingEditPbw || loadingDelete || loadingEditUser;
    const navigate = useNavigate();

    const [userData, setUserData] = React.useState({
        id: '',
        email: '',
        name: '',
        birthdate:'',
        gender: '',
        cpf: '',
        cb_pix: '',
    });
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [feedback, setFeedback] = React.useState({ type: '', message: '' });
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);

    React.useEffect(() => {
        setUserData({
        id: user.id ?? '',
        email: user.email ?? '',
        name: user.name ?? '',
        birthdate: user.birthdate ?? '',
        gender: user.gender ?? '',
        cpf: user.cpf ?? '',
        cb_pix: user.cb_pix ?? '',
        });
    }, [user]);

    const handleSavePassword = async () => {
        if (!newPassword || !confirmPassword) {
            setFeedback({ type: 'error', message: 'Por favor, preencha os dois campos de senha.' });
            return;
        }

        if (newPassword !== confirmPassword) {
            setFeedback({ type: 'error', message: 'As senhas não conferem.' });
            return;
        }

        try {
            await editUser({
            id: user.id,
            password: newPassword,
            });

            setFeedback({ type: 'success', message: 'Senha alterada com sucesso!' });
            setNewPassword('');
            setConfirmPassword('');
        } catch {
            setFeedback({ type: 'error', message: 'Erro ao alterar a senha. Tente novamente.' });
        }
    };


const handleSaveInfoGerais = async (newData) => {
    try {
        // Atualiza tabela 'users'
        if (newData.name || newData.email) {
            await editUser({
                id: userData.id, // Pega do estado ou contexto!
                ...(newData.name && { name: newData.name }),
                ...(newData.email && { email: newData.email }),
            });
        }

        // Atualiza tabela 'pbw_meucupom_users'
        if (newData.birthdate || newData.gender) {
            await editPbwUser(userData.id, {
                ...(newData.birthdate && { birthdate: newData.birthdate }),
                ...(newData.gender && { gender: newData.gender }),
            });
        }

        // Atualiza o estado local (merge de ambos)
        setUserData(prev => ({ ...prev, ...newData }));
        setFeedback({ type: 'success', message: 'Dados atualizados com sucesso!' });
        return true;
    } catch (error) {
        setFeedback({ type: 'error', message: 'Erro ao atualizar os dados.' });
        return false;
    }
};


    const handleSavePix = async (newData) => {
        try {
            await editPbwUser(newData.id ,{
            cpf: newData.cpf,
            cb_pix: newData.cb_pix,
            });
            setUserData(prev => ({ ...prev, cpf: newData.cpf, cb_pix: newData.cb_pix }));
            // Atualiza os dados do usuário no menu (some o aviso de chave Pix)
            notifyAuthChanged();
            setFeedback({ type: 'success', message: 'Informações Pix atualizadas com sucesso!' });
            return true;
        } catch {
            setFeedback({ type: 'error', message: 'Erro ao atualizar informações Pix. Tente novamente.' });
            return false;
        }
    };


    const handleOpenDeleteModal = () => {
        setOpenDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };
    const handleConfirmDelete = async () => {
        try {

            await deleteUser(userData.id);
            setFeedback({ type: 'success', message: 'Conta deletada com sucesso!' });
            goToHome(navigate, "/");
        } catch {
            setFeedback({ type: 'error', message: 'Erro ao deletar conta. Tente novamente.' });
        } finally {
            handleCloseDeleteModal();
        }
    };
    if (loading) {
            return (
            <FlexContainer justify="center" align="center" style={{ minHeight: '300px' }}>
                <CircularProgress color="primary" />
            </FlexContainer>
            );
    }
    
    return (
        <FlexContainer direction="column" gap="20px">
        <FlexContainer
            direction="column"
            justify="center"
            align="center"
            width={500}
            margin="auto"
            gap={20}
            style={{
            margin: 'auto',
            gap: 20,
            textAlign: 'center',
            maxWidth: 500,
            width: '100%',
            }}
        >
            <div>
            <h1>Meu Perfil</h1>
            <h4>
                Esse é o espaço onde você pode alterar todas as suas informações pessoais e preferências em nosso site.
            </h4>
            </div>
            <div>
            <Avatar sx={{ fontSize: '200px' }} />
            </div>
        </FlexContainer>
        <FlexContainer
            gap="20px"
            justify="center"
            wrap="wrap"
            width="100%"
            maxWidth="1200px"
            margin="0 auto"
            align="stretch"
            style={{ paddingLeft: '16px', paddingRight: '16px', overflow: 'hidden' }}
        >
            <S.StyledList>
                <S.LightBlueListItem>
                    <ListItemText primary="Informações Gerais" primaryTypographyProps={{ sx: { fontSize: '20px', fontWeight: 'bold' } }} />
                </S.LightBlueListItem>
                <Divider component="li" sx={{ borderColor: "transparent", backgroundColor: "transparent", height: "1px" }} />
                <ListItem>
                    <ListItemText primary={`Email: ${userData.email}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                    <ListItemText primary={`Nome: ${userData.name}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                    <ListItemText primary={`Data de Nascimento: ${userData.birthdate}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                    <ListItemText primary={`Gênero: ${userData.gender}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem>
                    <Gerais
                    title="Informações Gerais"
                    data={userData}
                    onSave={handleSaveInfoGerais}
                    loading={loading}
                    fields={[
                        { name: 'email', label: 'Email' },
                        { name: 'name', label: 'Nome' },
                        { name: 'birthdate', label: 'Data de Nascimento', type: 'date'},
                        { name: 'gender', label: 'Gênero', type: 'select', options: ['Não especificado', 'Feminino', 'Masculino',] },
                    ]}
                    />
                </ListItem>
            </S.StyledList>

            <S.StyledList>
                <S.LightGreenListItem>
                    <ListItemText primary="Área Pix" primaryTypographyProps={{ sx: { fontSize: '20px', fontWeight: 'bold' } }} />
                </S.LightGreenListItem>
                <ListItem sx={{ height: '58px' }}>
                    <ListItemText primary={`Cpf: ${userData.cpf}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem sx={{ height: '58px' }}>
                    <ListItemText primary={`Chave Pix: ${userData.cb_pix}`} />
                </ListItem>
                <Divider component="li" />
                <ListItem sx={{ height: '48px' }} />
                <ListItem sx={{ height: '48px' }} />
                <ListItem>
                    <Gerais
                    title="Área Pix"
                    data={userData}
                    onSave={(handleSavePix)}
                    loading={loading}
                    fields={[
                        { name: 'cpf', label: 'CPF' },
                        { name: 'cb_pix', label: 'Chave Pix' },
                    ]}
                    />
                </ListItem>
            </S.StyledList>
            <S.StyledList>
                <S.RedListItem>
                    <ListItemText
                    primary="Trocar Senha"
                    primaryTypographyProps={{ sx: { fontSize: '20px', fontWeight: 'bold' } }}
                    />
                </S.RedListItem>
                <ListItem sx={{ height: '58px' }}>
                    <S.NoBorderTextField
                    label="Nova Senha"
                    variant="standard"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    />
                </ListItem>

                <Divider component="li" />

                <ListItem sx={{ height: '58px' }}>
                    <S.NoBorderTextField
                    label="Confirmar Senha"
                    variant="standard"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </ListItem>

                <Divider component="li" />

                <ListItem sx={{ height: '48px' }}>
                    {feedback.type === 'error' && (
                    <ListItemText
                        primary={feedback.message}
                        sx={{ color: 'red', fontSize: '14px', paddingLeft: '8px' }}
                    />
                    )}
                </ListItem>

                <ListItem sx={{ height: '48px' }} /> {/* Preencher espaço pra bater altura */}

                <ListItem>
                    <Button variant="contained" onClick={handleSavePassword}>
                    Salvar
                    </Button>
                </ListItem>
            </S.StyledList>            
            <Snackbar
                open={!!feedback.type && feedback.type !== 'error'}
                autoHideDuration={4000}
                onClose={() => setFeedback({ type: '', message: '' })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                <Alert
                    onClose={() => setFeedback({ type: '', message: '' })}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    {feedback.message}
                </Alert>
            </Snackbar>
        </FlexContainer>
        
        {/* Botão Deletar conta */}
        <FlexContainer justify="center" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Button
            variant="contained"
            color="error"
            startIcon={loadingDelete ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
            onClick={handleOpenDeleteModal}
            >
            {loadingDelete ? 'Deletando...' : 'Deletar conta'}
            </Button>
        </FlexContainer>
            {/* Modal de confirmação */}
            <Dialog
                open={openDeleteModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="confirm-delete-dialog-title"
                aria-describedby="confirm-delete-dialog-description"
                PaperProps={{ sx: { borderRadius: 4 } }}
                sx={{
                    textAlign: 'center',
                }}
            >
                <DialogTitle id="confirm-delete-dialog-title"> Tem certeza que deseja deletar sua conta? Essa ação não pode ser desfeita.</DialogTitle>
                <DialogContent>
                <Typography id="confirm-delete-dialog-description">
                    Vamos sentir saudade de você :(
                </Typography>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseDeleteModal} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleConfirmDelete} color="error" variant="contained" autoFocus>
                    Confirmar
                </Button>
                </DialogActions>
            </Dialog>
        </FlexContainer>
    );
};

export default PerfilContainer;
